export default __webpack_public_path__ + "static/media/marketplace-grey.69811619.svg";